import { render, staticRenderFns } from "./set-score.vue?vue&type=template&id=34725bd2&scoped=true"
import script from "./set-score.vue?vue&type=script&lang=ts"
export * from "./set-score.vue?vue&type=script&lang=ts"
import style0 from "./set-score.vue?vue&type=style&index=0&id=34725bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34725bd2",
  null
  
)

export default component.exports